import React from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { useIntl } from 'react-intl';
import { ThemeMode } from 'config';
import { getLocalizedMessage } from '../../../../utils/localizationUtils';

/** "Show All" text link in the same style as the search history "Clear All" link. */
export default function ShowAllLink({ id, onClick }) {
  const theme = useTheme();
  const intl = useIntl();

  return (
    <Typography
      id={id}
      variant="body1"
      role="button"
      tabIndex={0}
      onClick={onClick}
      onKeyDown={(event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          onClick();
        }
      }}
      sx={{
        cursor: 'pointer',
        whiteSpace: 'nowrap',
        color: theme.palette.mode === ThemeMode.DARK ? 'color.default' : 'teal.900'
      }}
    >
      {getLocalizedMessage(intl, 'globalSearch.showAll', 'Show All')}
    </Typography>
  );
}

ShowAllLink.propTypes = {
  id: PropTypes.string,
  onClick: PropTypes.func.isRequired
};
